const allowFunctionalCookiesKey = 'allowFunctionalCookies'
class StorageHelperClass {
    private inMemoryStore: { [key: string]: string|null } = {}
    public get allowFunctionalCookies(): boolean {
        return localStorage.getItem(allowFunctionalCookiesKey) === 'true'
    }
    public set allowFunctionalCookies(newVal: boolean) {
        if(newVal) {
            localStorage.setItem(allowFunctionalCookiesKey, 'true')
        } else {
            localStorage.clear()
        }
    }

    public getItem(key: string): string|null {
        if(this.allowFunctionalCookies) {
            return localStorage.getItem(key)
        } else {
            return this.inMemoryStore[key]
        }        
    }
    public setItem(key: string, val: string) {
        if(this.allowFunctionalCookies) {
            localStorage.setItem(key, val)
        } else {
            this.inMemoryStore[key] = val;
        }
    }

    public removeItem(key: string) {
        if(this.allowFunctionalCookies) {
            localStorage.removeItem(key)
        } else {
            delete this.inMemoryStore[key]
        }
    }
}

const StorageHelper = new StorageHelperClass()
export default StorageHelper
